import React, { useMemo } from "react";
import DOMPurify from "dompurify";

// Renders HTML written in the admin panel (news, events, bios) after removing anything that can run
// script: <script>, event handlers (onerror=...), javascript: links, <iframe> and so on. A compromised
// admin account or a pasted snippet therefore cannot turn into stored XSS on the public site.
const SafeHtml = ({ html, as: Tag = "div", ...rest }) => {
  const clean = useMemo(
    () =>
      DOMPurify.sanitize(String(html ?? ""), {
        USE_PROFILES: { html: true },
        FORBID_TAGS: ["style", "form", "input", "button", "iframe", "object", "embed"],
      }),
    [html]
  );

  return <Tag {...rest} dangerouslySetInnerHTML={{ __html: clean }} />;
};

export default SafeHtml;
